import { useSelector } from "react-redux";
import { Route, Routes } from "react-router-dom";
import { allowedTabs } from "../constants/permissionCatalog";
import AdAnalytics from "../pages/dashboardPage/developer/adAnalytics/AdAnalytics";

// Tab id (permissionCatalog "developer") → its page.
const TAB_PAGES = {
  "ad-analytics": AdAnalytics,
};

const DeveloperNavigator = () => {
  const { rolePermissions } = useSelector((state) => state.user);
  const tabs = allowedTabs("developer", rolePermissions);
  const FirstTab = tabs[0] ? TAB_PAGES[tabs[0].id] : null;

  return (
    <Routes>
      {tabs.map((tab) => {
        const Page = TAB_PAGES[tab.id];
        return <Route key={tab.id} path={`/${tab.path}`} element={<Page />} />;
      })}
      {FirstTab && <Route path="*" element={<FirstTab />} />}
    </Routes>
  );
};

export default DeveloperNavigator;
